import { useEffect } from "react";

/**
 * Right-hand drawer: dimmed backdrop + full-height panel.
 * Full width on mobile, 420px on larger screens. Closes on backdrop click or Escape.
 */
export default function SidePanel({ open, onClose, label, children }) {
    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", handleKey);
            document.body.style.overflow = '';
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex justify-end" role="dialog" aria-modal="true" aria-label={label}>
            <div className="absolute inset-0 bg-black/50" onClick={onClose} />
            <div className="relative flex flex-col w-full sm:max-w-[420px] h-full bg-white shadow-2xl">
                {children}
            </div>
        </div>
    );
}